import { SEO_FIELDS_SLUG } from "common/SeoFields/constants";
import { WYSIWYG_SLUG } from "common/WYSIWYG/constants";
import { GEO_SLUG, POSITION_SLUG, PROGRAM_CARD_SLUG } from "./constants";

import type { DataSet } from "./types";

import { initialSEOData } from "common/SeoFields/interfaces";
import { initialWYSIWYGData } from "common/WYSIWYG/interfaces";
import { initialPositionData } from "./forms/position/interfaces";
import { initialProgramCardData } from "./forms/program-card/interfaces";
import { initialGEOData } from "common/Geo/interfaces";
import { initialFAQData } from "common/Faq/interfaces";
import { FAQ_SLUG } from "common/Faq/constants";

export const initialDataSet: DataSet = {
  [SEO_FIELDS_SLUG]: initialSEOData,
  [POSITION_SLUG]: initialPositionData,
  [PROGRAM_CARD_SLUG]: initialProgramCardData,
  [GEO_SLUG]: initialGEOData,
  [FAQ_SLUG]: initialFAQData,
  [WYSIWYG_SLUG]: initialWYSIWYGData,
};
